export default {
  "completePassword": {
    "button": {
      "submit": "Pošlji"
    },
    "header": "Izberi novo geslo",
    "placeholder": {
      "confirmPassword": "Potrdi geslo",
      "password": "Geslo"
    }
  },
  "dashboard": {
    "button": {
      "goToAllResults": "Vsi rezultati",
      "myActions": "MOJA DEJANJA",
      "ourCompanyResults": "NAŠI REZULTATI"
    },
    "card": {
      "body":
        "Tukaj lahko najdeš osebna dejanja, ki si jih izbral/a. Prav tako lahko vidiš svoj rezultat in njegovo primerjavo z rezultati celotne organizacije.",
      "title": "Dejanja in rezultati"
    },
    "greetings": {
      "day": "Živjo, {username}!",
      "evening": "Dober večer, {username}!",
      "morning": "Dobro jutro, {username}!",
      "night": "Lahko noč, {username}!",
      "simple": "Živjo!"
    },
    "hello": "Živjo {username}!",
    "integrations": {
      "title": "Integracije"
    },
    "introHeadline": "{productTitle} v {organizationName}",
    "settings": {
      "ar": "Arabski",
      "body": "Tukaj lahko spremeniš nastavitve svojega računa.",
      "da": "Danski",
      "de": "Nemški",
      "en": "Angleški",
      "fr": "Francoski",
      "logout": {
        "button": {
          "title": "Odjava"
        },
        "confirmation": {
          "areyousure":
            "Če se odjaviš, moraš zahtevati novo enkratno kodo, da se boš lahko znova prijavil/a.",
          "cancel": "Prekliči",
          "false": "Prekliči",
          "no": "Prekliči",
          "title": "Se želiš odjaviti?",
          "true": "Odjava",
          "yes": "Odjava"
        },
        "loggedin": "Prijavljen/a si kot {username}."
      },
      "no": "Norveški",
      "sv": "Švedski",
      "title": "Nastavitve"
    }
  },
  "error": {
    "CodeMismatchException":
      "Enkratna koda, ki si jo vnesel/a, ni veljavna. Preveri še enkrat in poskusi znova.",
    "couldNotLoadResults": "Ni bilo mogoče naložiti rezultatov, poskusi znova.",
    "couldNotLoadSurveys": "Ni bilo mogoče naložiti anket, poskusi znova.",
    "emailAtLeast3Letter": "E-poštni naslov mora vsebovati vsaj 3 črke",
    "emptyEmail": "Vnesi svoj e-poštni naslov",
    "emptyOrganization": "Vnesi ime svoje organizacije",
    "emptyPassword": "Vnesi geslo",
    "EternalLoopError":
      "Tvoj račun je videti neveljaven. Prosimo, kontaktiraj Puls podporo.",
    "ExpiredCodeException":
      "Enkratna koda, ki si jo vnesel/a, je prestara in je iz varnostnih razlogov ni mogoče uporabiti.",
    "InvalidParameterException": "Manjka obvezni parameter Session.",
    "InvalidPasswordException": "Izberi varnejše geslo.",
    "LimitExceededException":
      "Preveč neuspelih poskusov. Pred ponovnim poskusom moraš nekaj časa počakati.",
    "NotAuthorizedException":
      "Trenutno se ni mogoče prijaviti s tvojim uporabniškim računom.",
    "notMatchPassword": "Gesli se ne ujemata!",
    "OrganizationNotFoundException":
      "Organizacije s tem imenom nismo mogli najti, poskusi znova.",
    "UserNotFoundException":
      "Nismo mogli najti uporabnika {username}. Poskusi znova klikniti povezavo v vabilu po e-pošti!"
  },
  "forgotten": {
    "backToLogin": "Prekliči",
    "helptext":
      "Tukaj lahko ponastaviš geslo. Na zgornji e-poštni naslov boš prejel/a e-pošto s kodo, ki jo boš vnesel/a v naslednjem koraku.",
    "helptext-quickstart":
      "Pravkar smo ti poslali začasno kodo na {email}. Vnesi jo spodaj in izberi geslo.",
    "helptext2": "Izberi varno geslo.",
    "input": {
      "code": "Koda iz e-pošte",
      "organization": "Organizacija",
      "password": "Novo geslo",
      "username": "E-poštni naslov"
    },
    "requestcode": {
      "submit": "Nadaljuj"
    },
    "setNewPassword": {
      "submit": "Začni!"
    },
    "wait": "Počakaj..."
  },
  "general": {
    "defaultProductTitle": "Puls⁺"
  },
  "help": {
    "card": {
      "body":
        "Ti lahko kako pomagamo? Klikni spodnji gumb za prehod v center za pomoč.",
      "title": "Pomoč in podpora"
    },
    "description": "Ne skrbi, stojimo ti ob strani.",
    "title": "POMOČ"
  },
  "ie": {
    "detailedText":
      "Platformo Puls je mogoče uporabljati z Internet Explorerjem, vendar je to star spletni brskalnik, ki ni v skladu s sodobnimi spletnimi standardi. Zato priporočamo, da uporabljaš enega izmed spodaj navedenih brskalnikov. Lahko pa uporabljaš tudi svoj mobilni telefon.",
    "detailedTitle": "O Internet Explorerju",
    "readMore": "Preberi več",
    "warning":
      "Uporabljaš Internet Explorer. Priporočamo, da preklopiš na drug spletni brskalnik za najboljšo izkušnjo."
  },
  "integrations": {
    "addIntegrationSuccess": "Integracija je bila uspešno dodana!",
    "allIntegrations": "Vse integracije",
    "apps": {
      "sftp": {
        "connectionInfo": "Preneslo se bo v {dir} na SFTP strežniku.",
        "connectionTitle": "SFTP povezava",
        "title": "SFTP"
      },
      "slack": {
        "connectionInfo": "Povezano s kanalom {channel} v ekipi {teamName}",
        "connectionTitle": "Slack v {appDetail}",
        "title": "Slack"
      }
    },
    "back": "Nazaj",
    "buttons": {
      "deleteIntegration": {
        "help": "To bo odstranilo {type} iz Pulsa."
      }
    },
    "connectedSince": "Povezano od {date}",
    "empty": {
      "description":
        "Z dodajanjem integracije lahko Puls povežeš s svojo storitvijo. Izberi spodnji gumb za povezavo s storitvijo."
    },
    "errors": {
      "invalidIncomingIntegration":
        "Neveljavni vhodni podatki za integracijo! Ni mogoče nadaljevati."
    },
    "events": {
      "surveyCompleted": {
        "description":
          "Ko je anketa zaključena, se rezultati za {groupTitle} samodejno pošljejo v integracijo.",
        "title": "Anketa zaključena"
      },
      "title": "Izberi dogodek, ko je treba kontaktirati integracijo"
    },
    "groups": {
      "title": "Izberi skupino za povezavo z {appName}"
    },
    "integrationTo": "Integracija v {appName}",
    "nothingSelected": "Izberi...",
    "setupIntegration": {
      "saveButtonTitle": "Shrani",
      "title": "Nastavi integracijo v {appName}"
    },
    "title": "Integracije"
  },
  "loggedOut": {
    "loginButton": {
      "title": "Ponovno se prijavi"
    },
    "title": "Zdaj si odjavljen/a!"
  },
  "login": {
    "button": {
      "forgotPassword": "Pozabljeno geslo",
      "submit": "Prijava"
    },
    "captchaLegal": {
      "disclaimer":
        "Ta stran je zaščitena z reCAPTCHA sistemom in uporabljajo se Google {toc} in {privacyPolicy}.",
      "policy": "Politika zasebnosti",
      "toc": "Pogoji storitve"
    },
    "header": "Prijava",
    "placeholder": {
      "email": "E-poštni naslov",
      "organization": "Organizacija",
      "password": "Geslo"
    }
  },
  "navbar": {
    "welcome": "Dobrodošli"
  },
  "notFound": {
    "alert": "Ta stran ne obstaja. Prosim, vrni se nazaj.",
    "backButton": "Pregled",
    "title": "Ni najdeno"
  },
  "results": {
    "participants": "{participants} udeležencev",
    "surveys": {
      "completed": {
        "latest": "Zadnja izpolnjena anketa",
        "title": "Rezultati izpolnjenih anket"
      },
      "emptyResult": "Kmalu boš tukaj lahko videl/a rezultate!",
      "published": {
        "title": "Preveri rezultate"
      }
    }
  },
  "setup": {
    "attributes": {
      "birthdate": {
        "info":
          "To je potrebno za zbiranje statistike na podlagi različnih starostnih skupin.",
        "label": "Datum rojstva"
      },
      "birth_date": {
        "info":
          "To je potrebno za zbiranje statistike na podlagi različnih starostnih skupin.",
        "label": "Datum rojstva"
      },
      "custom:employed_since": {
        "info":
          "Datum, ko si bil/a zaposlen/a. Ni nujno, da je točen datum. Preskoči izbiro, če nisi zaposlen/a.",
        "label": "Zaposlen/a od"
      },
      "employment_date": {
        "info":
          "Datum, ko si bil/a zaposlen/a. Ni nujno, da je točen datum. Preskoči izbiro, če nisi zaposlen/a.",
        "label": "Zaposlen/a od"
      },
      "family_name": {
        "label": "Priimek"
      },
      "gender": {
        "other": "Drugo",
        "female": "Ženska",
        "info":
          "Sprašujemo o spolu, da ga lahko vključimo v statistiko. Ni ti treba ničesar izbrati, če tega ne želiš.",
        "label": "Izberi spol:",
        "male": "Moški",
        "wontsay": "Raje ne povem"
      },
      "given_name": {
        "label": "Ime"
      },
      "locale": {
        "ar": "Arabski",
        "da": "Danski",
        "de": "Nemški",
        "dk": "Danski",
        "en": "Angleški",
        "es": "Španski",
        "et": "Estonski",
        "fi": "Finski",
        "fr": "Francoski",
        "hr": "Hrvaški",
        "info":
          "Izberi jezik, ki ga želiš uporabljati. To lahko spremeniš tudi pozneje.",
        "it": "Italijanski",
        "label": "Izberi jezik:",
        "ms": "Malajski",
        "nl": "Nizozemski",
        "no": "Norveški",
        "pl": "Poljski",
        "ru": "Ruski",
        "sl": "Slovenski",
        "so": "Somalski",
        "sr": "Srbski",
        "sv": "Švedski",
        "uk": "Ukrajinski"
      }
    },
    "button": {
      "submit": "Shrani",
      "tryAgain": "Poskusi znova"
    },
    "error": {
      "badPassword": "Izberi varnejše geslo.",
      "clickLinkAgain":
        "Še enkrat klikni na povezavo v e-pošti dobrodošlice. Če se težava nadaljuje, se obrni na support@puls-solutions.com",
      "invalid": "Ta povezava ni več veljavna.",
      "noPassword": "Moraš izbrati geslo.",
      "passwordsMustMatch": "Gesli se morata ujemati.",
      "sessionError": "Naleteli smo na težavo!",
      "SSONotFound": "Za to organizacijo ni SSO konfiguracije.",
      "unexpected": "Prišlo je do nepričakovane težave"
    },
    "header": "Začni s Pulsom!",
    "introText":
      "Živjo{name}! Povabljen/a si v Puls, platformo za angažiranost sodelavcev. Aktiviraj svoj račun tako, da izpolniš spodnji obrazec. ",
    "introTextVolontary": "Obvezno je izpolniti le geslo.",
    "login": "Nadaljuj",
    "placeholder": {
      "confirmPassword": "Potrdi geslo",
      "newPassword": "Izberi geslo"
    }
  },
  "sso": {
    "button": {
      "continue": "Nadaljuj",
      "login": "SSO prijava",
      "signout": "Odjava"
    },
    "error": {
      "generic": "Prišlo je do težave med prijavo: {error}"
    },
    "noUserAccountFound": "V organizaciji ni bil najden uporabniški račun"
  },
  "start": {
    "button": {
      "getOrganizationData": {
        "title": "Nadaljuj"
      },
      "requestCode": {
        "title": "Pridobi enkratno kodo"
      },
      "submitCode": {
        "title": "Prijava"
      }
    },
    "confirmRequestCode": {
      "header": {
        "description":
          "Najprej želimo preveriti, da si res ti! Ko nadaljuješ, bo poslana enkratna koda. Uporabi jo v naslednjem koraku za prijavo v {productTitle} v {organizationName}.",
        "help":
          "Nedavno si zahteval/a kodo. Preveri, ali si kodo vnesel/a v okno, kjer si jo zahteval/a. Če nadaljuješ tukaj, bo poslana nova koda."
      }
    },
    "enterCode": {
      "form": {
        "code": {
          "placeholder": "enkratna koda"
        }
      },
      "header": {
        "deliveryMedium": {
          "EMAIL": "e-pošta",
          "SMS": "besedilno sporočilo"
        },
        "description":
          "Enkratna koda ti je bila poslana prek {deliveryMedium}. Pusti to okno odprto in se vrni sem, da spodaj vpišeš kodo:",
        "title": "Dobrodošel/a v {productTitle}!"
      },
      "help": {
        "noCodeDescriptionEmail":
          "Koda ti je bila poslana po e-pošti na naslov, ki vključuje '{destination}'. Pošiljatelj je »Puls«. Lahko traja minuto ali dve, preden prispe. Če je ne najdeš, preveri mapo z neželeno pošto. Pusti to okno odprto in vnesi kodo zgoraj.",
        "noCodeDescriptionSMS":
          "Koda je bila poslana kot besedilno sporočilo na tvoj mobilni telefon in telefonsko številko, ki vključuje '{destination}'. Lahko traja minuto ali dve, preden prispe. Če ne prepoznaš telefonske številke, se obrni na svojega administratorja.",
        "noCodeLinkTitle": "Nisi prejel/a kode?",
        "noCodeStartOverLinkTitle": "Začni znova"
      }
    },
    "enterEmail": {
      "form": {
        "username": {
          "placeholder": "e-poštni naslov"
        }
      },
      "header": {
        "description": "Vnesi svoj e-poštni naslov v {organizationName}:"
      }
    },
    "enterOrganization": {
      "form": {
        "organization": {
          "placeholder": "ime organizacije"
        }
      },
      "header": {
        "description": "Začni z vnosom imena organizacije, ki ji pripadaš.",
        "invalid": {
          "spaces": "Ne uporabljaj presledkov.",
          "specialchars": "Uporabljaj samo črke.",
          "uppercase": "Uporabljaj samo male črke."
        }
      }
    }
  },
  "surveys": {
    "description": "Te ankete trenutno potekajo:",
    "descriptionOneSurveyOnly": "Za začetek izberi spodnjo anketo!",
    "descriptionOneSurveyOnlyUserDone":
      "Anketa še vedno poteka. Izberi jo, da vidiš dejanja, ki si jih izbral/a.",
    "ended": "zaključeno",
    "youreDone": "Zaključil/a si"
  },
  "surveysToFillIn": {
    "description": "Te ankete trenutno potekajo:",
    "descriptionOneSurveyOnly": "Za začetek izberi spodnjo anketo!",
    "descriptionOneSurveyOnlyUserDone":
      "Anketa še vedno poteka. Izberi jo, da vidiš dejanja, ki si jih izbral/a.",
    "emptyResult":
      "Trenutno ni ankete, ki bi jo lahko izpolnil/a. Spodaj si lahko ogledaš svoja dejanja/komentarje ali rezultate.",
    "ended": "zaključeno",
    "endsIn": "se zaključi",
    "retry": "Poskusi znova",
    "title": "Trenutna anketa|Imaš anketo za izpolnitev|Čaka te {count} anket",
    "youreDone": "Zaključil/a si"
  },
  "user": {
    "attributes": {
      "birthdate": {
        "info":
          "To je potrebno za zbiranje statistike na podlagi različnih starostnih skupin.",
        "label": "Datum rojstva"
      },
      "birth_date": {
        "info":
          "To je potrebno za zbiranje statistike na podlagi različnih starostnih skupin.",
        "label": "Datum rojstva"
      },
      "custom:employed_since": {
        "info":
          "Datum, ko si bil/a zaposlen/a. Ni nujno, da je točen datum. Preskoči izbiro, če nisi zaposlen/a.",
        "label": "Zaposlen/a od"
      },
      "employment_date": {
        "info":
          "Datum, ko si bil/a zaposlen/a. Ni nujno, da je točen datum. Preskoči izbiro, če nisi zaposlen/a.",
        "label": "Zaposlen/a od"
      },
      "family_name": {
        "label": "Priimek"
      },
      "gender": {
        "other": "Drugo",
        "female": "Ženska",
        "info":
          "Sprašujemo o spolu, da ga lahko vključimo v statistiko. Ni ti treba ničesar izbrati, če tega ne želiš.",
        "label": "Izberi spol:",
        "male": "Moški",
        "wontsay": "Raje ne povem"
      },
      "given_name": {
        "label": "Ime"
      },
      "locale": {
        "ar": "Arabski",
        "da": "Danski",
        "de": "Nemški",
        "en": "Angleški",
        "es": "Španski",
        "et": "Estonski",
        "fi": "Finski",
        "fr": "Francoski",
        "hr": "Hrvaški",
        "info": "Izberi jezik, ki ga želiš uporabljati.",
        "it": "Italijanski",
        "label": "Izberi jezik:",
        "ms": "Malajski",
        "nl": "Nizozemski",
        "no": "Norveški",
        "pl": "Poljski",
        "ru": "Ruski",
        "sl": "Slovenski",
        "so": "Somalski",
        "sr": "Srbski",
        "sv": "Švedski",
        "uk": "Ukrajinski",
        "zh": "Kitajski"
      }
    },
    "button": {
      "cancel": "Prekliči",
      "skip": "Pojdi nazaj",
      "submit": "Shrani",
      "tryAgain": "Poskusi znova"
    },
    "error": {
      "badPassword": "Izberi varnejše geslo.",
      "clickLinkAgain":
        "Še enkrat klikni na povezavo v e-pošti dobrodošlice. Če se težava nadaljuje, se obrni na support@puls-solutions.com",
      "invalid": "Ta povezava ni več veljavna, namesto tega klikni spodaj:",
      "noPassword": "Moraš izbrati geslo.",
      "passwordsMustMatch": "Gesli se morata ujemati.",
      "sessionError": "Naleteli smo na težavo!",
      "SSONotFound": "Za to organizacijo ni SSO konfiguracije.",
      "unexpected": "Prišlo je do nepričakovane težave"
    },
    "header": "Uporabniške nastavitve",
    "introText": "Preveri, ali je tvoj uporabniški profil pravilen.",
    "introTextNoAttributes": "Tukaj trenutno ni nastavitev za spremembo.",
    "introTextVolontary": "Spodnje informacije so prostovoljne.",
    "login": "Nadaljuj"
  },
  "whistleblower": {
    "buttons": {
      "cancel": "Prekliči",
      "done": "V redu",
      "send": "Pošlji anonimno"
    },
    "description":
      "Omogočamo ti, da anonimno pošlješ prijavo o nezakonitem ravnanju ali prekršku, ki si mu bil/a priča v {organizationName}.",
    "detailedDescription":
      "Tako to deluje. Svoje poročilo vpišeš v spodnje besedilno polje. Ko pošlješ poročilo, se e-pošta pošlje vnaprej določenemu prejemniku v tvoji organizaciji, ki je odgovoren za ukrepanje. Prejemnik ne more videti, da si sporočilo poslal/a ti; vidi le, da je prispelo s platforme Puls. Če želiš, da te kontaktiramo, v sporočilo obvezno vključi informacije o tem. Če želiš ostati anonimen/na, lahko uporabiš enkratni (začasni) e-poštni naslov ali SIM kartico za mobilni telefon.",
    "doneText":
      "Hvala za poslano prijavo. Obravnavali jo bomo resno. Če si navedel/a kontaktne podatke, se ti bomo oglasili čim prej!",
    "linkTitle": "Preberi več tukaj",
    "linkToHelp": "https://www.puls-solutions.com/help/TODO",
    "notEnabled": {
      "description":
        "Oprostite. Funkcija za žvižgače pri tvoji organizaciji ni omogočena.",
      "title": "Ni na voljo"
    },
    "placeholder":
      "Tukaj vnesi svojo prijavo. Bodi čim bolj natančen/na in nam povej, ali želiš, da te kontaktiramo, in kako.",
    "title": "Pošlji anonimno prijavo"
  }
}
